import React, { useEffect } from 'react';
import ReactRouterPrompt from 'react-router-prompt';
import { CustomModal } from '../../../../components/uikit/modal/CustomModal.tsx';
import { ButtonColor } from '../../../../components/uikit/buttons/Button.tsx';
import pageStyles from '../WarrantyRequest.module.scss';
import { Trans } from 'react-i18next';
import { useScopedTranslation } from '../../../../application/localization/useScopedTranslation.ts';
import { useNavigate, useOutletContext } from 'react-router';

type OutletContext = {
  isTryingToLogout: boolean;
  setIsTryingToLogout: (value: boolean) => void;
  logout: () => void;
};

type OwnProps = {
  showSubmitModal: () => void;
  isActive: boolean;
};

const fakeRedirect = 'fakeRedirect';

export const RemindModalWarrantyRequest = (props: OwnProps) => {
  const i18n = useScopedTranslation('Page.WarrantyPage');
  const navigate = useNavigate();

  const { showSubmitModal, isActive } = props;

  const { logout, setIsTryingToLogout, isTryingToLogout }: OutletContext =
    useOutletContext();

  useEffect(() => {
    if (isActive && isTryingToLogout) {
      // we need this for firing remind modal blocker func
      void navigate('/create-warranty-request', {
        state: fakeRedirect,
      });
    } else if (!isActive && isTryingToLogout) {
      logout();
    }
  }, [isActive, isTryingToLogout]);

  return (
    <ReactRouterPrompt
      when={(args) => {
        if (!args) return false;
        const { currentLocation, nextLocation } = args;
        if (
          currentLocation.pathname === nextLocation.pathname &&
          currentLocation.state !== fakeRedirect &&
          nextLocation.state !== fakeRedirect
        ) {
          return false;
        }

        return isActive;
      }}
      // we need to resolve Promise in order to call onConfirm and onCancel functions
      beforeConfirm={() => {
        if (isTryingToLogout) {
          logout();
        }

        return new Promise((res) => res(null));
      }}
      beforeCancel={() => {
        setIsTryingToLogout(false);
        return new Promise((res) => res(null));
      }}
    >
      {({ isActive, onConfirm, onCancel }) =>
        isActive && (
          <CustomModal
            isOpen={true}
            onSubmit={() => {
              onCancel();
              showSubmitModal();
            }}
            onCancel={onConfirm}
            onClose={onCancel}
            cancelButtonText={i18n.t('leave_without_submitting')}
            submitButtonText={i18n.t('submit_warranty_request')}
            submitButtonType={ButtonColor.Primary}
            titleText={i18n.t('unsubmitted_request')}
            containerClassName={pageStyles.modalBodyMinWidth480}
          >
            <Trans i18nKey="Page.WarrantyPage.unsubmitted_request_modal_body" />
          </CustomModal>
        )
      }
    </ReactRouterPrompt>
  );
};
